module.exports = __webpack_public_path__ + "img/plan4_book06.f6888c8d.png";